import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const get = async ({ invoiceId = '', ...params }) => {
  return await recurrenceAPI.get(`/invoices/${invoiceId}`, { params })
}

const downloadCsv = async ({ ...params }) => {
  return await recurrenceAPI.get(`/invoices.csv/`, {
    params,
  })
}

const getByContract = async ({ contractId = '', ...params }) => {
  return await recurrenceAPI.get(`/contracts/${contractId}/invoices`, {
    params,
  })
}

const create = async ({ contractId = '', ...data }) => {
  return await recurrenceAPI.post(`/contracts/${contractId}/invoices`, data)
}

const manualConfirmation = async ({ invoiceId, ...params }) => {
  return await recurrenceAPI.post(`/invoices/${invoiceId}/confirm`, { params })
}

const cancel = async ({ invoiceId, ...params }) => {
  return await recurrenceAPI.post(`/invoices/${invoiceId}/cancel`, params)
}

const resend = async ({ contractId, invoiceId }) => {
  return await recurrenceAPI.post(
    `/contracts/${contractId}/invoices/${invoiceId}/regenerate_order`,
  )
}

const changeDueDate = async ({ invoiceId, params }) => {
  return await recurrenceAPI.put(
    `/invoices/${invoiceId}/update_corp_due_date`,
    params,
  )
}

const reverse = async ({ invoiceId, ...params }) => {
  return await recurrenceAPI.post(`invoices/${invoiceId}/reverse`, params)
}

const verifyOrders = async ({ invoiceId }) => {
  return await recurrenceAPI.post(`/invoices/${invoiceId}/verify_orders`)
}

const detached = async ({ ...params }) => {
  return await recurrenceAPI.post(`invoices/detached`, params)
}

export default {
  get,
  downloadCsv,
  getByContract,
  create,
  manualConfirmation,
  cancel,
  resend,
  changeDueDate,
  reverse,
  verifyOrders,
  detached,
}
